import { render } from "./FooterView.vue?vue&type=template&id=47f1e270&scoped=true&ts=true"
import script from "./FooterView.vue?vue&type=script&lang=ts"
export * from "./FooterView.vue?vue&type=script&lang=ts"

import "./FooterView.vue?vue&type=style&index=0&id=47f1e270&lang=scss&scoped=true"

import exportComponent from "E:\\leilongObject\\庆亚\\qingya_v3\\qingya_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f1e270"]])

export default __exports__